import React, { useEffect } from "react";
import RichCard from "./RichCard/RichCard";
import { Card } from "react-bootstrap";
import { connect } from "react-redux";
import { loadTrainings } from "redux/actions/trainingActions";
import { IsNullOrEmptyOrUndefined } from "utils/validatorHelpers";

function HomePage({ trainings, userId, loadTrainings, selectedDate }) {
  const headerStyles = {
    margin: "0px 0px 10px",
    fontFamily: "system-ui",
    fontWeight: "600",
  };

  const cardBodyStyles = {
    display: "flex",
    justifyContent: "space-around",
  };

  const contentStyles = {
    display: "grid",
    justifyContent: "space-around",
  };

  useEffect(() => {
    if (!IsNullOrEmptyOrUndefined(userId)) {
      loadTrainings(userId).catch((error) => {
        console.log("Wystąpił problem z załadowaniem treningów: " + error);
      });
    }
  }, [userId]);

  return (
    <div style={contentStyles}>
      <h4 style={headerStyles}>Twój plan dnia</h4>
      <Card bg="light">
        <Card.Body style={cardBodyStyles}>
          <RichCard data={trainings} date={selectedDate} />
        </Card.Body>
      </Card>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    trainings: state.trainings,
    userId: state.user.selectedUser?.userId || state.auth.userId,
    selectedDate: state.core.selectedDate,
  };
}

const mapDispatchToProps = { loadTrainings };

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
